<template>
  <footer class="text-color-light" :class="{ 'is-mobile': isMobileFooter }" :style="{ minHeight: footerHeight, maxHeight: footerHeight }">
    <div v-if="!isMobileFooter" class="desktop-footer">
      <div class="row justify-content-between align-items-center">
        <div class="col-md-6 text-small">
          © Created by the
          <a href="#" class="text-neon text-small">IT Development Team</a>
          of AI Analytics.
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <a class="nav-link d-flex align-items-center" href="https://aialphaanalytics.com/" target="_blank">
                <img src="/images/logos/SiteLogo.png" alt="Isotipo AI Analytics en fondo oscuro." class="logo mx-2" />
                <p class="text-small mb-0">AI Alpha Analytics Website</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else class="mobile-footer">
      <div class="text-center">
        <a class="nav-link d-flex justify-content-center align-items-center" href="https://aialphaanalytics.com/" target="_blank">
          <p class="text-small mb-0">AI Alpha Analytics Website</p>
          <img src="/images/logos/SiteLogo.png" alt="Isotipo AI Analytics en fondo oscuro." class="logo" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { GlobalMixin } from '@mixins/GlobalMixin';
import { footerHeight } from '@states/FooterState';

export default {
  mixins: [GlobalMixin],
  name: 'Footer',
  data() {
    return {
      isMobileFooter: false,
    };
  },
  setup() {
    return { footerHeight };
  },
  mounted() {
    // ------------ Responsividad ------------
    this.handleResize('isMobileFooter', 1300);
    window.addEventListener('resize', () => this.handleResize('isMobileFooter', 1300));
    // ------------ Responsividad ------------
  },
  beforeUnmount() {
    // ------------ Responsividad ------------
    window.removeEventListener('resize', this.handleResize);
    // ------------ Responsividad ------------
  },
};
</script>

<style scoped lang="scss">
footer {
  background-color: var(--Obscure-Sky);
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 0;
  padding-bottom: 0 !important;
  z-index: 100;
  font-size: 0.875rem;
  font-weight: 400;
  transition: 0.3s ease-in-out;
  overflow: hidden;

  .desktop-footer {
    .row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 2dvh;
    }

    .nav-link {
      color: var(--Light);
      font-size: 0.875rem;
      display: flex;
      align-items: center;
      margin-right: 4dvh;
    }

    .logo {
      max-width: 2.5dvh;
      max-height: 2.5dvh;
      margin-left: 10px;
    }
  }

  .mobile-footer {
    text-align: center;
    margin-top: 1dvh;

    .nav-link {
      color: var(--Light);
      font-size: 0.675rem;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }

    .logo {
      max-width: 2dvh;
      max-height: 2dvh;
      margin-left: 1dvh;
    }
  }
}
</style>
